var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    fill: "#EA5455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 15H27V14C27 12.3 25.7 11 24 11H20C18.3 11 17 12.3 17 14V15H13C12.4 15 12 15.4 12 16C12 16.6 12.4 17 13 17H14V30C14 31.7 15.3 33 17 33H27C28.7 33 30 31.7 30 30V17H31C31.6 17 32 16.6 32 16C32 15.4 31.6 15 31 15ZM19 14C19 13.4 19.4 13 20 13H24C24.6 13 25 13.4 25 14V15H19V14ZM27 31C27.6 31 28 30.6 28 30V17H16V30C16 30.6 16.4 31 17 31H27ZM21 21V27C21 27.6 20.6 28 20 28C19.4 28 19 27.6 19 27V21C19 20.4 19.4 20 20 20C20.6 20 21 20.4 21 21ZM25 27V21C25 20.4 24.6 20 24 20C23.4 20 23 20.4 23 21V27C23 27.6 23.4 28 24 28C24.6 28 25 27.6 25 27Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_5192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 20,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 15H27V14C27 12.3 25.7 11 24 11H20C18.3 11 17 12.3 17 14V15H13C12.4 15 12 15.4 12 16C12 16.6 12.4 17 13 17H14V30C14 31.7 15.3 33 17 33H27C28.7 33 30 31.7 30 30V17H31C31.6 17 32 16.6 32 16C32 15.4 31.6 15 31 15ZM19 14C19 13.4 19.4 13 20 13H24C24.6 13 25 13.4 25 14V15H19V14ZM27 31C27.6 31 28 30.6 28 30V17H16V30C16 30.6 16.4 31 17 31H27ZM21 21V27C21 27.6 20.6 28 20 28C19.4 28 19 27.6 19 27V21C19 20.4 19.4 20 20 20C20.6 20 21 20.4 21 21ZM25 27V21C25 20.4 24.6 20 24 20C23.4 20 23 20.4 23 21V27C23 27.6 23.4 28 24 28C24.6 28 25 27.6 25 27Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_5192)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ec2fba9a0684a755e97f5d1c47c33c8a.svg";
export { ForwardRef as ReactComponent };